import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import normalizeHeaderRenderer from './normalizeHeaderRenderer';
import styles from './reachHeaderRenderer.module.scss';

const ReachHeaderRenderer = ({ messageIdPrefix, field, headerName }) => (
    <div className={styles.container}>
        <FormattedMessage id={`${messageIdPrefix}.${field}`} defaultMessage={headerName} />
        <span className={styles.newBadge}>New</span>
    </div>
);

ReachHeaderRenderer.propTypes = {
    messageIdPrefix: PropTypes.string,
    field: PropTypes.string,
    headerName: PropTypes.string,
};

export default normalizeHeaderRenderer(ReachHeaderRenderer);
